module.exports = __webpack_public_path__ + "img/logo-light.d6c87e17.svg";